import { render, staticRenderFns } from "./DatabaseNavigationDrawer.vue?vue&type=template&id=82bc5622"
import script from "./DatabaseNavigationDrawer.vue?vue&type=script&lang=js"
export * from "./DatabaseNavigationDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports